<template>
  <div class="main">
    <AllHeader title="行业动态"></AllHeader>
    <NewsList  fenlei="行业动态"></NewsList>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
import NewsList from "@/components/NewsList.vue";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
  },
  components: {
    AllHeader,NewsList
  }
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  margin-top: 20px;
}
</style>